import React from "react";

// styles
import styles from "./TableContainer.module.scss";
import cx from "classnames";

interface ITableProps {
    title?: string;
    footnote?: string | React.ReactNode;
    className?: string;
}

const TableContainer: React.FC<ITableProps> = (props) => {
    const { title, footnote, children, className } = props;

    return (
        <div
            className={cx([
                styles["tablelist-container"],
                "gap-m",
                {
                    [className]: !!className
                }
            ])}>
            {title && <h2 className="text-font-size-l text-primary">{title}</h2>}
            {children}
            {footnote && (
                <div
                    className={cx(
                        styles["tablelist-container-footer"],
                        "text-font-size-xs",
                        "text-disclaimer"
                    )}>
                    {footnote}
                </div>
            )}
        </div>
    );
};

export default TableContainer;
